import Box from "@mui/material/Box";
import { MainPageHeader } from "./MainPageHeader";
import { MainPageList } from "./MainPageList";
import { EmployeeCreate } from "entitites/employees/ui";
import { EmployeeView } from "entitites/employees/ui/EmployeeView/EmployeeView";
import { useLocation } from "react-router-dom";
import { useGetMyRolesQuery } from "entitites/casdoor/api/casdoorApi";

export const MainPage = () => {
  const { pathname } = useLocation();
  const { data: roles } = useGetMyRolesQuery();

  return (
    <Box pt={2.5} display="flex" flexDirection="column" height="100%" gap={2.5}>
      <MainPageHeader isAdmin={Boolean(roles?.includes("staffdesk-admin"))} />
      {pathname.split("/")[2] && <EmployeeView />}
      <Box
        position="relative"
        bgcolor="background.paper"
        height="100%"
        borderRadius="4px 4px 0px 0px"
        pt={0.25}
        px={0.25}
      >
        <MainPageList />
      </Box>
      {Boolean(roles?.includes("staffdesk-admin")) && <EmployeeCreate />}
    </Box>
  );
};
